import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import FCoverImage from '@/components/FCoverImage';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FTooltip from '@/components/FTooltip';
import * as AHooks from 'ahooks';
import FCheckbox from '@/components/FCheckbox';
import FIcons from '@/components/FIcons';
import { ReactSortable } from 'react-sortablejs';
import FInput_PinyinSafeTextCounter from '../FInput_PinyinSafeTextCounter';
import FReactSortable from '../FReactSortable';

interface FExhibitCollectionListProps {
  items: {
    itemID: string;
    itemTitle: string;
    itemSerial: number;
    exhibtInfo: {
      id: string;
      cover: string;
      name: string;
      title: string;
      intro: string;
      resourceID: string;
      resourceType: string[];
      releaseDateTime: string;
      isAuth: boolean;
      authErrorText: string;
    };
  }[];

  showCheckbox: 'show' | 'hide';
  checkedItemIDs: string[];
  showTitle: 'title' | 'serial' | 'custom' | 'customNotEdited' | 'hide';
  showNumber: 'show' | 'hide';
  showCover: 'show' | 'hide';
  showIntroduction: 'show' | 'hide';

  draggable?: boolean;

  onChangeChecked?(itemsID: string, checked: boolean): void;

  onClickDelete?(itemID: string): void;

  onClick?(itemID: string, exhibitID: string, resourceID: string): void;

  onChangeIndex?(
    itemID: string,
    index: number,
    newList: FExhibitCollectionListProps['items'],
  ): void;
}

interface FExhibitCollectionListStates {
  items: {
    id: string;
    itemID: string;
    itemTitle: string;
    itemSerial: number;
    // itemNumber: string;
    exhibtInfo: {
      id: string;
      cover: string;
      name: string;
      title: string;
      intro: string;
      resourceID: string;
      resourceType: string[];
      releaseDateTime: string;
      isAuth: boolean;
      authErrorText: string;
    };
  }[];
}

function FExhibitCollectionList({
  items,
  onClickDelete,
  onClick,
  showCheckbox,
  checkedItemIDs,
  draggable,
  onChangeChecked,
  showTitle,
  showNumber,
  showCover,
  showIntroduction,
  onChangeIndex,
}: FExhibitCollectionListProps) {
  const [$introTooltipOpen, set$introTooltipOpen, get$introTooltipOpen] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$customTitleMouseEnter, set$customTitleMouseEnter, get$customTitleMouseEnter] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$resourceCardOpen, set$resourceCardOpen, get$resourceCardOpen] =
    FUtil.Hook.useGetState<boolean>(false);

  const [$items, set$items, get$items] = FUtil.Hook.useGetState<
    FExhibitCollectionListStates['items']
  >(
    items.map((r) => {
      return {
        id: r.itemID,
        ...r,
      };
    }),
  );

  AHooks.useDebounceEffect(
    () => {
      set$items(
        items.map((r) => {
          return {
            id: r.itemID,
            ...r,
          };
        }),
      );
    },
    [items],
    {
      wait: 100,
    },
  );

  return (
    <FReactSortable
      className={styles.list}
      style={{
        display: 'flex',
        gap: 10,
        flexWrap: 'wrap',
      }}
      // list={$items}
      // setList={(newState, sortable, store) => {
      //   set$items(newState);
      // }}

      // onEnd={(evt) => {
      //   // console.log(evt, 'isodjflksdklflsjdfjls;dfj');
      //   const items: FExhibitCollectionListStates['items'] = get$items();
      //   const index: number = evt.newDraggableIndex ?? -1;
      //   const id: string = items[index]?.id || '';
      //   const newList = items.map(({ id, ...r }) => {
      //     return r;
      //   });
      //   // console.log(id, index, newList, '89ewijf;klsdjflkjdskljfk;lsjdklfjlksdjflksdjlkj');
      //   onChangeIndex?.(id, index, newList);
      // }}
      options={{
        onEnd: (evt) => {
          // console.log(evt, 'isodjflksdklflsjdfjls;dfj');
          const items: FExhibitCollectionListStates['items'] = get$items();
          const index: number = evt.newDraggableIndex ?? -1;
          const id: string = items[index]?.id || '';
          const newList = items.map(({ id, ...r }) => {
            return r;
          });
          // console.log(id, index, newList, '89ewijf;klsdjflkjdskljfk;lsjdklfjlksdjflksdjlkj');
          onChangeIndex?.(id, index, newList);
        },
        handle: '.' + styles.dragHandle,
        forceAutoScrollFallback: true,
        disabled: !draggable,
      }}
      // chosenClass={''}
      // dragClass={''}
      // disabled={!draggable}
    >
      {$items.map((i, j) => {
        return (
          <div key={i.itemID} className={styles.item}>
            {showCheckbox !== 'hide' && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <FCheckbox
                  checked={checkedItemIDs.includes(i.itemID)}
                  onChange={(e) => {
                    onChangeChecked?.(i.itemID, e.target.checked);
                  }}
                />
              </div>
            )}

            {showNumber === 'show' && <div className={styles.serial}>{i.itemSerial || -1}</div>}

            <a
              className={styles.body}
              onClick={() => {
                onClick?.(i.itemID, i.exhibtInfo.id, i.exhibtInfo.resourceID);
              }}
              style={{ cursor: onClick ? 'pointer' : 'auto' }}
              title={
                !onClick || $introTooltipOpen || $customTitleMouseEnter || $resourceCardOpen
                  ? undefined
                  : FI18n.i18nNext.tAuto('cqr_itemmgmt_entry_tooltips')
              }
            >
              {
                // setting.collection_item_image_display === 'collection_item_image_display_show'
                showCover === 'show' && (
                  <>
                    <div
                      // style={{
                      //   opacity: i.resourceInfo.status === 2 ? 0.4 : 1,
                      // }}
                      className={styles.bodyCover}
                    >
                      <Cover
                        cover={i.exhibtInfo.cover}
                        width={
                          showTitle !== 'hide' && showIntroduction !== 'hide'
                            ? 88
                            : showTitle === 'hide' && showIntroduction === 'hide'
                            ? 44
                            : 60
                        }
                      />

                      {/* {i.resourceInfo.isChoice && (
                        <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                          <img
                            src={img_choiceLabel}
                            alt={''}
                            style={{
                              width: 16,
                              height: 16,
                              position: 'absolute',
                              top: 4,
                              left: 4,
                            }}
                          />
                        </FTooltip>
                      )} */}
                    </div>

                    <div style={{ flexBasis: 10, flexShrink: 0 }} />
                  </>
                )
              }

              <div
                // style={{
                //   opacity: i.resourceInfo.status === 2 ? 0.4 : 1,
                // }}
                className={styles.bodyInfo}
              >
                {showTitle === 'title' && (
                  <OverflowTooltip text={i.itemTitle} className={styles.title} />
                )}

                {
                  // setting.collection_item_descr_display === 'collection_item_descr_display_show'
                  showIntroduction === 'show' && (
                    <OverflowTooltip
                      text={i.exhibtInfo.intro || FI18n.i18nNext.tAuto('no_short_description')}
                      className={styles.intro}
                      style={{ opacity: i.exhibtInfo.intro ? 1 : 0.6 }}
                      afterOpenChange={(o) => {
                        // console.log(o, '***************************************');
                        set$introTooltipOpen(o);
                      }}
                    />
                  )
                }

                <BaseInfo
                  exhibtInfo={i.exhibtInfo}
                  onOpenChange={(o) => {
                    set$resourceCardOpen(o);
                  }}
                />
              </div>

              <div
                style={{
                  flexBasis: 100,
                  flexShrink: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {/* {i.resourceInfo.status !== 2 && i.resourceInfo.authProblem && (
                  <FTooltip
                    // title={'存在授权问题'}
                    title={FI18n.i18nNext.tAuto('alert_resource_no_auth')}
                  >
                    <FIcons.FWarning style={{ fontSize: 16 }} />
                  </FTooltip>
                )}
                {i.resourceInfo.status === 2 && <FResourceStatusBadge status={'freeze'} />} */}

                {!i.exhibtInfo.isAuth && (
                  <FTooltip title={i.exhibtInfo.authErrorText}>
                    <FIcons.FWarning />
                  </FTooltip>
                )}

                {draggable && (
                  <a className={styles.dragHandle} title={'拖动排序'}>
                    <FIcons.FDrag style={{ color: '#666' }} />
                  </a>
                )}
              </div>
            </a>
            {onClickDelete && (
              <div
                className={styles.delete}
                onClick={() => {
                  onClickDelete(i.itemID);
                }}
              >
                <FIcons.FDelete />
              </div>
            )}
          </div>
        );
      })}
    </FReactSortable>
  );
}

export default FExhibitCollectionList;

interface BaseInfoProps {
  // resourceInfo: {
  //   id: string;
  //   cover: string;
  //   name: string;
  //   title: string;
  //   version: string;
  //   policy: string[];
  //   type: string[];
  //   status: 0 | 1 | 2 | 4;
  //   authProblem: boolean;
  //   updateDate: string;
  //   username: string;
  //   useAvatar: string;
  //   isChoice: boolean;
  //   intro: string;
  //   releaseDateTime?: string;
  // };

  exhibtInfo: {
    id: string;
    cover: string;
    name: string;
    title: string;
    intro: string;
    resourceType: string[];
    releaseDateTime: string;
  };

  onOpenChange?(o: boolean): void;
}

export function BaseInfo({ exhibtInfo, onOpenChange }: BaseInfoProps) {
  const ref = React.useRef<any>(null);

  return (
    <div
      style={{
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        width: '100%',
      }}
      ref={ref}
    >
      <FComponentsLib.FContentText
        text={FI18n.i18nNext.tAuto('cqr_itemmgmt_entry_resourceinfo')}
        type={'additional2'}
        style={{ color: '#666', flexBasis: 'fit-content', flexShrink: 0 }}
      />
      <div
        style={{ width: 'fit-content' }}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <FComponentsLib.FTextBtn
          type='default'
          onClick={() => {
            // window.open(FUtil.LinkTo.resourceDetails({ resourceID: resourceInfo.id }));
            window.open(FUtil.LinkTo.exhibitManagement({ exhibitID: exhibtInfo.id }));
          }}
        >
          <FComponentsLib.FContentText
            text={exhibtInfo.name}
            type={'additional2'}
            style={{
              color: 'inherit',
              textDecoration: 'underline',
              maxWidth: 200,
            }}
            singleRow
          />
        </FComponentsLib.FTextBtn>
      </div>
      <FComponentsLib.FContentText
        text={'|'}
        type={'additional2'}
        style={{ color: '#666', flexBasis: 'fit-content', flexShrink: 0 }}
      />
      <FComponentsLib.FContentText
        text={exhibtInfo.resourceType.join('/')}
        type={'additional2'}
        style={{ color: '#666', flexBasis: 'fit-content', flexShrink: 0 }}
      />
      <FComponentsLib.FContentText
        text={'|'}
        type={'additional2'}
        style={{ color: '#666', flexBasis: 'fit-content', flexShrink: 0 }}
      />
      <FComponentsLib.FContentText
        // text={`更新时间${resourceInfo.updateDate}`}
        text={FI18n.i18nNext.tAuto('cqr_itemmgmt_entry_lastupdated', {
          Timestamp: exhibtInfo.releaseDateTime,
        })}
        type={'additional2'}
        style={{ color: '#666', flexBasis: 'fit-content', flexShrink: 1 }}
        singleRow
      />
    </div>
  );
}

interface CoverProps {
  cover: string;
  width: number;
}

function Cover({ width, cover }: CoverProps) {
  return (
    <div
      style={{
        flexBasis: width,
        height: (width / 4) * 3,
        borderRadius: 4,
        flexShrink: 0,
      }}
    >
      <FCoverImage src={cover} width={width} />
    </div>
  );
}

interface OverflowTooltipProps {
  text: string;
  className?: string;
  style?: React.CSSProperties;

  afterOpenChange?(visible: boolean): void;
}

export function OverflowTooltip({ text, className, style, afterOpenChange }: OverflowTooltipProps) {
  const ref = React.useRef<any>(null);
  const [$visible, set$visible] = FUtil.Hook.useGetState<boolean | undefined>(false);

  return (
    <FTooltip
      title={text}
      open={$visible}
      trigger={[]}
      // afterOpenChange={afterOpenChange}
    >
      <div
        className={className}
        style={style}
        ref={ref}
        onMouseEnter={(e) => {
          if (
            ref.current.clientWidth < ref.current.scrollWidth ||
            ref.current.clientHeight < ref.current.scrollHeight
          ) {
            set$visible(true);
            afterOpenChange?.(true);
          }
        }}
        onMouseLeave={() => {
          set$visible(false);
          afterOpenChange?.(false);
        }}
      >
        {text}
      </div>
    </FTooltip>
  );
}

interface CustomTitleInputProps {
  value: string;

  onChange?(value: string): void;

  onMouseEnter?(enter: boolean): void;
}

export function CustomTitleInput({ value, onChange, onMouseEnter }: CustomTitleInputProps) {
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<string>(value);

  AHooks.useDebounceEffect(
    () => {
      if (value !== get$value()) {
        set$value(value);
      }
    },
    [value],
    {
      wait: 1,
    },
  );

  const { run } = AHooks.useDebounceFn(
    () => {
      onChange && onChange(get$value());
    },
    {
      wait: 300,
    },
  );

  return (
    <div
      style={{ width: '100%' }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onMouseEnter={() => {
        onMouseEnter?.(true);
      }}
      onMouseLeave={() => {
        onMouseEnter?.(false);
      }}
    >
      {/* <FComponentsLib.FInput.FSingleLine */}
      <FInput_PinyinSafeTextCounter
        lengthLimit={100}
        size={'small'}
        value={$value}
        style={{ width: '100%' }}
        onChangeValue={(v) => {
          set$value(v.substring(0, 100));
          run();
        }}
      />
    </div>
  );
}
